'use client';

import {useState} from 'react';
import Image from 'next/image';
import {AppBar, Box, IconButton, Toolbar} from '@mui/material';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars} from "@fortawesome/pro-duotone-svg-icons";
import useMediaQuery from '@mui/material/useMediaQuery';
import SearchButton from "@/src/components/main-site/_partials/header/search/search-button";
import SupportButton from "@/src/components/main-site/_partials/header/support-button/support-button";
import DrawerMenu from "@/src/components/main-site/_partials/header/drawer-menu/drawer-menu";
import ThemeToggle from "@/src/components/main-site/_partials/header/theme-toggle/theme-toggle";
import DesktopMenu from "@/src/components/main-site/_partials/header/desktop-menu/desktop-menu";
import SignInButton from "@/src/components/main-site/_partials/header/sign-in-button/sign-in-button";
import MenuItem from "@/src/_types/menu-item";
import {mapToMenuItems} from "@/src/utils/database-helpers/menu-helper";

const MainSiteHeader = ({journalTitle, mainJournal, journal}: {
    journalTitle: string,
    mainJournal: any,
    journal: any
}) => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'));
    const menuItems: MenuItem[] = mainJournal.menu ? mapToMenuItems(mainJournal.menu, mainJournal) : [];
    const toggleDrawer = (open: boolean) => {
        setDrawerOpen(open);
    };

    const url = journal.slug;

    return (
        <>
            <AppBar
                position='static'
                sx={{
                    boxShadow: 'none',
                }}
            >
                <Toolbar
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        minHeight: '0 !important'
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flex: 1,
                        gap: .5,
                        justifyContent: {
                            xs: 'space-between',
                            md: 'flex-start'
                        },
                    }}>
                        {
                            isSmallScreen && (
                                <IconButton
                                    color="inherit"
                                    onClick={() => toggleDrawer(true)}
                                >
                                    <FontAwesomeIcon
                                        icon={faBars}
                                    />
                                </IconButton>
                            )
                        }
                        <Image
                            src="/logo.svg"
                            alt={"Logo"}
                            width={128}
                            height={25}
                        />
                        <SearchButton/>
                    </Box>
                    {
                        !isSmallScreen && (
                            <>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flex: 1,
                                        justifyContent: 'center'
                                    }}
                                >
                                    <DesktopMenu
                                        menuItems={menuItems}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flex: 1,
                                        justifyContent: 'flex-end'
                                    }}
                                >
                                    <SupportButton
                                        url={journal.meta_data?.support_url ?? '#'}
                                    />
                                    {
                                        journalTitle !== 'main' && url && (
                                            <SignInButton url={url}/>
                                        )
                                    }
                                    <ThemeToggle/>
                                </Box>
                            </>
                        )
                    }
                </Toolbar>
                <DrawerMenu
                    open={drawerOpen}
                    toggleDrawer={toggleDrawer}
                    menuItems={menuItems}
                    mainJournal={mainJournal}
                    mainSite={journalTitle === 'main'}
                    supportUrl={journal.meta_data?.support_url ?? '#'}
                    signInUrl={url}
                />
            </AppBar>
        </>
    );
};

export default MainSiteHeader;
